import { api } from "@/lib/api";
import { HeartStraight, HandsPraying, Sun, UsersThree } from "@phosphor-icons/react";
import { formatDistanceToNow } from "date-fns";

const REACTIONS = [
  { key: "heart", icon: HeartStraight, label: "Love" },
  { key: "hug", icon: HandsPraying, label: "Hug" },
  { key: "hope", icon: Sun, label: "Hope" },
  { key: "same", icon: UsersThree, label: "Same" },
];

export default function PostCard({ post, onChanged }) {
  const react = async (emoji) => {
    try { await api.post(`/posts/${post.id}/react`, { emoji }); onChanged?.(); } catch {}
  };
  const when = (() => {
    try { return formatDistanceToNow(new Date(post.created_at), { addSuffix: true }); }
    catch { return ""; }
  })();
  return (
    <article className="bg-white border border-border rounded-2xl p-5 shadow-soft hover:shadow-card transition-shadow"
             data-testid={`post-${post.id}`}>
      <header className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-sage-100 border border-sage-200 grid place-items-center font-display text-sm text-sage-700">
          {post.anonymous ? "?" : post.author_anon.slice(0, 1)}
        </div>
        <div>
          <div className="font-display text-base">{post.anonymous ? "Anonymous" : post.author_anon}</div>
          <div className="text-xs text-muted-foreground">{when}{post.condition ? ` · ${post.condition}` : ""}</div>
        </div>
      </header>
      <p className="mt-4 text-ink/90 leading-relaxed whitespace-pre-wrap">{post.body}</p>
      {post.tags?.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {post.tags.map(t => (
            <span key={t} className="text-xs px-2.5 py-1 rounded-full bg-muted text-muted-foreground">#{t}</span>
          ))}
        </div>
      )}
      <div className="mt-4 pt-3 border-t border-border flex items-center gap-1">
        {REACTIONS.map(({ key, icon: Icon, label }) => {
          const count = post.reactions?.[key] || 0;
          return (
            <button key={key} onClick={() => react(key)}
                    data-testid={`react-${post.id}-${key}`}
                    aria-label={`${label} reaction${count ? `, ${count} ${count === 1 ? "peer has" : "peers have"} reacted` : ""}`}
                    className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full hover:bg-coral-50 hover:text-coral-700 transition-colors">
              <Icon size={14} weight="duotone" aria-hidden="true" />
              <span>{label}</span>
              {count > 0 && (
                <span className="text-[10px] font-mono text-muted-foreground" aria-hidden="true">{count}</span>
              )}
            </button>
          );
        })}
      </div>
    </article>
  );
}
